import i18next from "i18next"
import { Accordion, Button, Col, Form, Modal, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import Skeleton from "react-loading-skeleton"
import { FieldProductSpec } from "src/components/FieldProductSpec"
import { UserProductType, UserSegment } from "src/components/mikro/getHakAkses"
import { PriceFormater } from "src/components/mikro/PriceFormater"

type Prop = {
    addInOrder: any
    orderSelect: any
    onclickCheckBox: any
    sektorID: any
    selectedIndex: any
    isLoadingModal: any
    setIndexOrder: any
    setShow2: any
    show2: any
}

const ApprovalSIPDetailChooseItem: React.FC<Prop> = ({
    addInOrder,
    orderSelect,
    onclickCheckBox,
    sektorID,
    selectedIndex,
    isLoadingModal,
    setIndexOrder,
    setShow2,
    show2,
}) => {

    const {t} = useTranslation()

    return (
        <>
            <Modal
            show={show2}
            onHide={() => {
              setShow2(false)
              setIndexOrder([])
            }}
            backdrop='static'
            keyboard={false}
            centered
            scrollable
            size='xl'
          >
            <Modal.Header closeButton>
              <Modal.Title>{t('pilih')} Item</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {isLoadingModal ? (
                <Skeleton width={100} height={30} />
              ) : (
                <>
                  <Accordion>
                    {orderSelect.map((data: any, _index: any) => (
                      <>
                        {/* <label>{indexOrder.indexOf(_index)} {indexOrder[_index]}</label> */}
                        {selectedIndex.indexOf(_index) == -1 && (
                          <>
                            <Accordion.Item eventKey={data?.id}>
                              <Accordion.Header>
                                {data?.id} / {data?.produsen?.name} / {data?.product_name} /{' '}
                                {data?.incoterm1?.code}
                                {data?.incoterm2 == null
                                  ? data?.incoterm2_id == null || data?.incoterm2_id == '0'
                                    ? ''
                                    : ' - ' + data?.incoterm2_id
                                  : ' - ' + data?.incoterm2?.code}{' '}
                                /{' '}
                                {data?.provice
                                  ? data?.province?.region_name +
                                    ' - ' +
                                    data?.city?.city_name +
                                    ' /'
                                  : ''}{' '}
                                {(i18next.language === 'en'
                                  ? data?.fixed_quantum?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : data?.fixed_quantum?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })) + (data?.sector_id === 3 ? ' MT' : ' Ton')}
                                {sektorID == '1' &&
                                  (data?.include_ppn ? ' / Include PPN' : ' / Exclude PPN')}
                              </Accordion.Header>
                              <Accordion.Body style={{backgroundColor: 'white'}}>
                                {sektorID == '2' && ( <>
                                  <Row>
                                    <Col md={6}>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6'>{t('pilih')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <input
                                            className='form-check-input'
                                            type='checkbox'
                                            id={'checkbox' + _index}
                                            value={_index}
                                            disabled={!data?.have_action}
                                            onClick={() => onclickCheckBox(_index)}
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-item')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control value={data?.id} disabled size='sm' />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>Sales Org</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.produsen?.name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-wilayah')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.province?.region_name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-Gudang')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.plant_desc}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-nama')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.product_name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('sub-order-kuantum')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              i18next.language === 'en'
                                                ? data?.request_quantum?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' Ton'
                                                : data?.request_quantum?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' Ton'
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col md={6}>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 '>Status</p>
                                        </Col>
                                        <Col md={8}>
                                          <span className='d-block '>
                                            <span className='badge badge-light-primary'>
                                              {t(data?.status_text)}
                                            </span>
                                          </span>
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('Sektor')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={t(data?.sector?.name)}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-incoterm')}</p>
                                        </Col>
                                        <Col md={8}>
                                          {data?.sector?.id == 2 ? (
                                            <>
                                              {data?.incoterm2 == null ? (
                                                <Form.Control
                                                  value={
                                                    data?.incoterm1?.code + ' - ' + data?.incoterm2_id
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              ) : (
                                                <Form.Control
                                                  value={
                                                    data?.incoterm1?.code +
                                                    ' - ' +
                                                    data?.incoterm2?.code
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {data?.incoterm2 == null ? (
                                                <Form.Control
                                                  value={
                                                    data?.incoterm2_id == null ||
                                                    data?.incoterm2_id == '0'
                                                      ? data?.incoterm1?.code
                                                      : data?.incoterm1?.code +
                                                        '-' +
                                                        data?.incoterm2_id
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              ) : (
                                                <Form.Control
                                                  value={
                                                    data?.incoterm1?.code +
                                                    ' - ' +
                                                    data?.incoterm2?.code
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              )}
                                            </>
                                          )}
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('sub-order-kota')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={t(data?.city?.city_name)}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-jenis')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.product_type_desc}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('kontrak-spek')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <FieldProductSpec data={data?.product_spec} />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('sub-order-hargaP')}/Ton</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              'Rp' + i18next.language === 'en'
                                                ? data?.request_price?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : data?.request_price?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                </>
                                )}

                                {sektorID == '1' && (
                                  <Row>
                                    {!UserProductType(data?.product_type) && (
                                      <Col md={12} className='mb-4'>
                                        <div className='alert alert-warning'>
                                          {t('not-match-product-type')}
                                        </div>
                                      </Col>
                                    )}
                                    {!UserSegment(data?.segment_code) && (
                                      <Col md={12} className='mb-4'>
                                        <div className='alert alert-warning'>
                                          {t('not-match-segment')}
                                        </div>
                                      </Col>
                                    )}
                                    <Col md={6}>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 '>{t('pilih')}</p>
                                        </Col>
                                        <Col md={8}>
                                          {UserSegment(data?.segment_code) ? (
                                            <>
                                              <input
                                                className='form-check-input'
                                                type='checkbox'
                                                id={'checkbox' + _index}
                                                value={_index}
                                                disabled={!UserProductType(data?.product_type)}
                                                onClick={() => onclickCheckBox(_index)}
                                              />
                                            </>
                                          ) : (
                                            <>
                                              <span
                                                data-bs-toggle='tooltip'
                                                data-bs-placement='top'
                                                data-bs-trigger='hover'
                                                title={t('not-match-segment')}
                                              >
                                                <input
                                                  className='form-check-input'
                                                  type='checkbox'
                                                  disabled
                                                />
                                              </span>
                                            </>
                                          )}
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-item')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control value={data?.id} disabled size='sm' />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>Sales Org</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.produsen?.name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-wilayah')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.province?.region_name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-jenis')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.product_type_desc}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6 '>{t('Kuantum Pengajuan')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              i18next.language === 'en'
                                                ? data?.request_quantum?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' Ton'
                                                : data?.request_quantum?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' Ton'
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6 '>{t('sub-order-kuantumD')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              i18next.language === 'en'
                                                ? data?.fixed_quantum?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' Ton'
                                                : data?.fixed_quantum?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' Ton'
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('Shipping Tolerance')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              data?.shipping_tolerance > 1
                                                ? data?.shipping_tolerance + '%'
                                                : ''
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.payment_type_1_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('keterangan')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.payment_note}
                                            as='textarea'
                                            style={{height: '40px'}}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('segment')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            type='text'
                                            value={t(data?.segment_name)}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('End Customer')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.end_user}
                                            as='textarea'
                                            style={{height: '40px'}}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col md={6}>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 '>Status</p>
                                        </Col>
                                        <Col md={8}>
                                          <span className='d-block '>
                                            <span className='badge badge-light-primary'>
                                              {t(data?.status_text)}
                                            </span>
                                          </span>
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('Sektor')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={t(data?.sector?.name)}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-incoterm')}</p>
                                        </Col>
                                        <Col md={8}>
                                          {data?.sector?.id == 2 ? (
                                            <>
                                              {data?.incoterm2 == null ? (
                                                <Form.Control
                                                  value={
                                                    data?.incoterm1?.code + ' - ' + data?.incoterm2_id
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              ) : (
                                                <Form.Control
                                                  value={
                                                    data?.incoterm1?.code +
                                                    ' - ' +
                                                    data?.incoterm2?.code
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {data?.incoterm2 == null ? (
                                                <Form.Control
                                                  value={
                                                    data?.incoterm2_id == null ||
                                                    data?.incoterm2_id == '0'
                                                      ? data?.incoterm1?.code
                                                      : data?.incoterm1?.code +
                                                        '-' +
                                                        data?.incoterm2_id
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              ) : (
                                                <Form.Control
                                                  value={
                                                    data?.incoterm1?.code +
                                                    ' - ' +
                                                    data?.incoterm2?.code
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              )}
                                            </>
                                          )}
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('sub-order-kota')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={t(data?.city?.city_name)}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-nama')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.product_name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6 '>{t('sub-order-hargaP')}/Ton</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              'Rp' + i18next.language === 'en'
                                                ? data?.request_price?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : data?.request_price?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-3'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6 '>{t('sub-order-hargaD')}/Ton</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            aria-label='Default select example'
                                            size='sm'
                                            value={
                                              'Rp' + i18next.language === 'en'
                                                ? data?.fixed_price?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : data?.fixed_price?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })
                                            }
                                            disabled
                                          />
                                        </Col>
                                      </Row>

                                      <Row className='my-7'>
                                        <Col sm={6} className='d-flex '>
                                          <Row sm={8} className='d-flex align-items-center'>
                                            <p className='fs-6 '>{t('termasuk-ppn')}</p>
                                          </Row>
                                          <Row
                                            sm={4}
                                            className='d-flex justify-content-start align-items-center ms-4'
                                          >
                                            <Form.Check
                                              reverse
                                              name='ppn'
                                              type='checkbox'
                                              id='ckbox-ppn'
                                              checked={data?.include_ppn}
                                            />
                                          </Row>
                                        </Col>
                                        <Col sm={6} className='d-flex'>
                                          <Row sm={8} className='d-flex align-items-center'>
                                            <p className='fs-6 '>{t('Formulated Price')}</p>
                                          </Row>
                                          <Row
                                            sm={4}
                                            className='d-flex justify-content-start align-items-center ms-4'
                                          >
                                            <Form.Check
                                              reverse
                                              name='formulated_price'
                                              type='checkbox'
                                              id='formulated_price'
                                              checked={data?.is_formulated_price}
                                            />
                                          </Row>
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.payment_type_2_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('kontrak-spek')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <FieldProductSpec data={data?.product_spec} />
                                        </Col>
                                      </Row>

                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            as='textarea'
                                            style={{height: '40px'}}
                                            value={data?.notes}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                )}

                                {sektorID == '3' && (
                                  <Row>
                                    {!UserProductType(data?.product_type) && (
                                      <Col md={12} className='mb-4'>
                                        <div className='alert alert-warning'>
                                          {t('not-match-product-type')}
                                        </div>
                                      </Col>
                                    )}
                                    {!UserSegment(data?.segment_code) && (
                                      <Col md={12} className='mb-4'>
                                        <div className='alert alert-warning'>
                                          {t('not-match-segment')}
                                        </div>
                                      </Col>
                                    )}
                                    <Col md={6}>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6'>{t('pilih')}</p>
                                        </Col>
                                        <Col md={8}>
                                          {UserSegment(data?.segment_code) ? (
                                            <>
                                              <input
                                                className='form-check-input'
                                                type='checkbox'
                                                id={'checkbox' + _index}
                                                value={_index}
                                                disabled={!UserProductType(data?.product_type)}
                                                onClick={() => onclickCheckBox(_index)}
                                              />
                                            </>
                                          ) : (
                                            <>
                                              <span
                                                data-bs-toggle='tooltip'
                                                data-bs-placement='top'
                                                data-bs-trigger='hover'
                                                title={t('not-match-segment')}
                                              >
                                                <input
                                                  className='form-check-input'
                                                  type='checkbox'
                                                  disabled
                                                />
                                              </span>
                                            </>
                                          )}
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-item')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control value={data?.id} disabled size='sm' />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>Sales Org</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.produsen?.name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-wilayah')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.province?.region_name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-jenis')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.product_type_desc}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('Kuantum Pengajuan')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              i18next.language === 'en'
                                                ? data?.request_quantum?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' MT'
                                                : data?.request_quantum?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' MT'
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('sub-order-kuantumD')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              i18next.language === 'en'
                                                ? data?.fixed_quantum?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' MT'
                                                : data?.fixed_quantum?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' MT'
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('Shipping Tolerance')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              data?.shipping_tolerance > 1
                                                ? data?.shipping_tolerance + '%'
                                                : ''
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.payment_type_1_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('kontrak-spek')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <FieldProductSpec data={data?.product_spec} />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('keterangan')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.payment_note}
                                            as='textarea'
                                            style={{height: '40px'}}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>

                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('End Customer')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.end_user}
                                            as='textarea'
                                            style={{height: '40px'}}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col md={6}>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6'>Status</p>
                                        </Col>
                                        <Col md={8}>
                                          <span className='d-block '>
                                            <span className='badge badge-light-primary'>
                                              {t(data?.status_text)}
                                            </span>
                                          </span>
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('Sektor')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={t(data?.sector?.name)}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-incoterm')}</p>
                                        </Col>
                                        <Col md={8}>
                                          {data?.sector?.id == 2 ? (
                                            <>
                                              {data?.incoterm2 == null ? (
                                                <Form.Control
                                                  value={
                                                    data?.incoterm1?.code + ' - ' + data?.incoterm2_id
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              ) : (
                                                <Form.Control
                                                  value={
                                                    data?.incoterm1?.code +
                                                    ' - ' +
                                                    data?.incoterm2?.code
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {data?.incoterm2 == null ? (
                                                <Form.Control
                                                  value={
                                                    data?.incoterm2_id == null ||
                                                    data?.incoterm2_id == '0'
                                                      ? data?.incoterm1?.code
                                                      : data?.incoterm1?.code +
                                                        '-' +
                                                        data?.incoterm2_id
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              ) : (
                                                <Form.Control
                                                  value={
                                                    data?.incoterm1?.code +
                                                    ' - ' +
                                                    data?.incoterm2?.code
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              )}
                                            </>
                                          )}
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('sub-order-kota')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={t(data?.city?.city_name)}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-nama')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.product_name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>

                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('sub-order-hargaP')}/MT</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              'USD' + PriceFormater(data?.request_price) + '/MT'
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>

                                      <Row className='mb-3'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('sub-order-hargaD')}/MT</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            aria-label='Default select example'
                                            size='sm'
                                            value={'USD' + PriceFormater(data?.fixed_price) + '/MT'}
                                            disabled
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='my-7'>
                                        <Col sm={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('Formulated Price')}</p>
                                        </Col>
                                        <Col
                                          sm={8}
                                          className='d-flex justify-content-start align-items-center'
                                        >
                                          <Form.Check
                                            reverse
                                            name='formula_Price'
                                            type='checkbox'
                                            value={data?.is_formulated_price}
                                            disabled
                                            id='formula_Price'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.payment_type_2_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>

                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            as='textarea'
                                            style={{height: '40px'}}
                                            value={data?.notes}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                )}
                              </Accordion.Body>
                            </Accordion.Item>
                          </>
                        )}
                      </>
                    ))}
                  </Accordion>
                  <div className='d-flex justify-content-end mt-5'>
                    <Button
                      className='justify-content-end me-1'
                      onClick={() => addInOrder('all')}
                      hidden={orderSelect.length < 2 ? true : false}
                    >
                      {t('selectall')}
                    </Button>
                    <Button
                      className='justify-content-end'
                      hidden={orderSelect.length < 1 ? true : false}
                      onClick={() => addInOrder('satuan')}
                    >
                      {t('Save')}
                    </Button>
                  </div>
                </>
              )}
            </Modal.Body>
          </Modal>
        </>
    )
}

export default ApprovalSIPDetailChooseItem